import Vue from "vue";
import Router from "vue-router";

import MainPage from "../components/layout/MainPage.vue";
import MainLayout from "../components/layout/MainLayout.vue";
import IntroLayout from "../components/layout/IntroLayout.vue";

import PersonalPolicy from "../components/footer/PersonalPolicy.vue";
import Email from "../components/footer/Email.vue";

import Test1 from "../components/layout/test1.vue";

import sitemap from "../components/layout/sitemap.vue";

import Login from "../components/layout/Login.vue";

import Sub01MainMenu from '../components/sub01/Sub01MainMenu.vue';
import EducationSupport from '../components/sub01/EducationSupport.vue';
import PlanningBusiness from '../components/sub01/PlanningBusiness.vue';
import ScholarshipSelection from '../components/sub01/ScholarshipSelection.vue';


import Sub02MainMenu from '../components/sub02/Sub02MainMenu.vue';
import NoticeList from '../components/sub02/NoticeList.vue';
import NewsList from '../components/sub02/NewsList.vue';

import BannerList from '../components/sub02/BannerList.vue';
import BannerDetail from '../components/sub02/BannerDetail.vue';
import BannerWritePopup from '../components/sub02/BannerWritePopup.vue';

import PopupList from "../components/sub02/PopupList.vue";
import PopupDetail from "../components/sub02/PopupDetail.vue";
import PopupWritePopup from "../components/sub02/PopupWritePopup.vue";

import BoardDetail from '../components/sub02/BoardDetail.vue';
import NoticeWritePopup from '../components/sub02/NoticeWritePopup.vue';

import Sub03MainMenu from '../components/sub03/Sub03MainMenu.vue';
import Establishment from '../components/sub03/Establishment.vue';
import History from '../components/sub03/History.vue';
import Location from '../components/sub03/Location.vue';


Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/main",
      component: MainLayout,
      children: [
        {
          path: "main",
          component: MainPage,
          name: "MainPage"
        },
        {
          path: "Email",
          component: Email
        },
        {
          path: "business",
          component: Sub01MainMenu,
          children: [
            {
              path: "educationsupport",
              component: EducationSupport
            },
            {
              path: "planningbusiness",
              component: PlanningBusiness
            },
            {
              path: "ScholarshipSelection",
              component: ScholarshipSelection
            },
          ]
        },

        {
          path: "notice",
          component: Sub02MainMenu,
          children: [
            {
              path: "detail",
              component: BoardDetail,
            },
            {
              path: "NoticeWritePopup",
              component: NoticeWritePopup
            },
            {
              path: "noticelist",
              component: NoticeList,

            },
            {
              path: "newslist",
              component: NewsList,
            },
            {
              path: "bannerlist",
              component: BannerList,
            },
            {
              path: "bannerdetail",
              component: BannerDetail,
            },
            {
              path: "BannerWritePopup",
              component: BannerWritePopup,
            },
            {
              path: "popupList",
              component: PopupList,
            },
            {
              path: "popupDetail",
              component: PopupDetail,
            },
            {
              path: "PopupWritePopup",
              component: PopupWritePopup,
            },
          ]
        },
        {
          path: "intro",
          component: Sub03MainMenu,
          children: [
            {
              path: "establishment",
              component: Establishment
            },
            {
              path: "history",
              component: History
            },
            {
              path: "location",
              component: Location
            },

          ]
        },
        {
          path: "PersonalPolicy",
          component: PersonalPolicy
        },

        {
          path: "sitemap",
          component: sitemap
        }
      ]
    },
    {
      path: "/Intro",
      component: IntroLayout,
      children: [
        {
          path: "/login",
          component: Login
        },
        {
          path: "/test",
          component: Test1
        },
      ]
    },


    {
      path: "*",
      redirect: "/"
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
    // 원하는 위치로 돌아가기
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js